module.exports = __webpack_public_path__ + "img/deliver.bf699f72.png";